export const calculatePregnancyWeek = (dueDate: string, referenceDate: Date = new Date()): number => {
  if (!dueDate) return 0;
  // Parse YYYY-MM-DD strictly as local time to avoid timezone shifts
  const [y, m, d] = dueDate.split('-').map(Number);
  const due = new Date(y, m - 1, d);
  
  // Pregnancy is 40 weeks (280 days)
  const timeDiff = due.getTime() - referenceDate.getTime();
  const daysRemaining = Math.ceil(timeDiff / (1000 * 3600 * 24));
  
  const daysPassed = 280 - daysRemaining;
  const currentWeek = Math.floor(daysPassed / 7);
  
  // Clamp between 1 and 42
  return Math.max(1, Math.min(42, currentWeek));
};

export const formatDuration = (seconds: number): string => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
};

export const formatDateForDisplay = (isoDate: string): string => {
  if (!isoDate) return '';
  const [y, m, d] = isoDate.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(date);
};

export const getMonthData = (year: number, month: number) => {
  const firstDay = new Date(year, month, 1).getDay(); // 0 = Sunday
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  return { firstDay, daysInMonth };
};